'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _lifecycle = require('recompose/lifecycle');

var _lifecycle2 = _interopRequireDefault(_lifecycle);

var _getContext = require('recompose/getContext');

var _getContext2 = _interopRequireDefault(_getContext);

var _withState = require('recompose/withState');

var _withState2 = _interopRequireDefault(_withState);

var _propTypes = require('prop-types');

var _Menu = require('./Menu');

var _Menu2 = _interopRequireDefault(_Menu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var Menu = (0, _composeWithScope2.default)((0, _getContext2.default)({
  server: _propTypes.object.isRequired
}), (0, _withState2.default)('groups', 'setGroups', []), (0, _lifecycle2.default)({
  componentDidMount: function componentDidMount() {
    var _this = this;

    return _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
      var _props, get, setGroups, menu;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _props = _this.props, get = _props.server.get, setGroups = _props.setGroups;
              _context.next = 3;
              return get({ url: '/api/route/menu' });

            case 3:
              menu = _context.sent;

              setGroups(menu);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  }
}), (0, _exposeProps2.default)(['groups']))(_Menu2.default);

Menu.displayName = 'Menu';

exports.default = Menu;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/Menu/index.js
// module id = 1262
// module chunks = 0